// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2VBen","title":"Images45_title__2KM2x","images":"Images45_images__26DJn"};